var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white create-partner"
  }, [_c('div', {
    staticClass: "flex justify-between items-stretch shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:w-full mdmax:flex-auto"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Tambah Business Merchant")]), _c('div', {
    staticClass: "mb-6 max-w-sm"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "ID",
      "disabled": true
    },
    model: {
      value: _vm.id,
      callback: function ($$v) {
        _vm.id = $$v;
      },
      expression: "id"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama Perusahaan/Company Name",
      "notes": "Pastikan nama perusahaan belum terdaftar sebelumnya (duplikasi).",
      "placeholder": "Nama perusahaan",
      "required": ""
    },
    model: {
      value: _vm.payloads.name,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "name", $$v);
      },
      expression: "payloads.name"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama Admin Pengirim",
      "placeholder": "Masukan nama admin",
      "required": ""
    },
    model: {
      value: _vm.payloads.sender_name,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "sender_name", $$v);
      },
      expression: "payloads.sender_name"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Email",
      "placeholder": "Masukan email",
      "required": ""
    },
    model: {
      value: _vm.payloads.email,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "email", $$v);
      },
      expression: "payloads.email"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "number",
      "label": "No. Handphone",
      "placeholder": "Masukan no handphone",
      "required": ""
    },
    model: {
      value: _vm.payloads.sender_phone,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "sender_phone", $$v);
      },
      expression: "payloads.sender_phone"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Password (optional)",
      "notes": "Jika password tidak diisi maka sistem akan mengirimkan password sementara ke email yang terdaftar.",
      "placeholder": "Masukan password"
    },
    model: {
      value: _vm.payloads.password,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "password", $$v);
      },
      expression: "payloads.password"
    }
  })], 1)]), _c('div', {
    staticClass: "flex-1 mdmax:w-full mdmax:flex-auto"
  }, [_c('div', {
    staticClass: "p-6"
  }, [_c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Label Alamat (optional)",
      "placeholder": "Masukan label alamat"
    },
    model: {
      value: _vm.payloads.address_label,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "address_label", $$v);
      },
      expression: "payloads.address_label"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('Textarea', {
    attrs: {
      "type": "text",
      "label": "Pickup Point/Alamat Pengiriman (Sertakan Kecamatan & Kelurahan)",
      "placeholder": "Masukan alamat pengiriman",
      "required": ""
    },
    model: {
      value: _vm.payloads.pickup_address,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "pickup_address", $$v);
      },
      expression: "payloads.pickup_address"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Petunjuk Pengiriman",
      "placeholder": "Masukan petujuk sebagai patokan"
    },
    model: {
      value: _vm.payloads.detail_address,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "detail_address", $$v);
      },
      expression: "payloads.detail_address"
    }
  })], 1), _c('div', {
    staticClass: "mb-6 text-left relative"
  }, [_vm._m(0), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "withIcon": "",
      "type": "text",
      "placeholder": "Kota / Kecamatan / Kode POS Pengirim"
    },
    on: {
      "input": function ($event) {
        return _vm.searchCity($event);
      }
    },
    model: {
      value: _vm.destinationSearch,
      callback: function ($$v) {
        _vm.destinationSearch = $$v;
      },
      expression: "destinationSearch"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1), _vm.isSearching ? _c('img', {
    staticClass: "w-8 absolute top-1/2 transform -translate-y-1/2 right-2",
    attrs: {
      "src": require("@/assets/images/rolling.gif")
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.visibleSuggestion ? _c('div', {
    staticClass: "mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white"
  }, [_vm.cities ? _c('ul', {
    staticClass: "max-h-40 overflow-y-scroll"
  }, _vm._l(_vm.cities, function (city, index) {
    return _c('li', {
      key: 'city-' + index,
      staticClass: "cursor-pointer px-3 py-2 hover:bg-neutral-300",
      on: {
        "click": function ($event) {
          return _vm.selectCity(city);
        }
      }
    }, [_vm._v(" " + _vm._s(city.village) + ", " + _vm._s(city.area_display) + " ")]);
  }), 0) : _c('div', {
    staticClass: "py-4 text-center"
  }, [_vm._v("Maaf data tidak ditemukan!")])]) : _vm._e()])], 1)]), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Koordinat Alamat (optional)",
      "placeholder": "Latitude, Longitude"
    },
    model: {
      value: _vm.payloads.latlng,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "latlng", $$v);
      },
      expression: "payloads.latlng"
    }
  })], 1)])])]), _c('div', {
    staticClass: "flex gap-6 p-6 justify-end"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Simpan",
      "size": _vm.isMobile ? 'full' : 'regular',
      "disabled": _vm.isDisabled
    },
    on: {
      "action": function ($event) {
        return _vm.submit();
      }
    }
  })], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_c('span', {
    staticClass: "text-system-error"
  }, [_vm._v("*")]), _vm._v("Kota / Kecamatan / Kode POS Pengirim")]);

}]

export { render, staticRenderFns }